import { ROUTES } from '../types/navigationTypes';
import { parseHashToRoute } from './navigationUtils';
import { SupportedOperation } from '@amzn/snow-data-service-typescript-client';

export interface RouteHandlerActions {
	navigateToApplications: () => void;
	navigateToAddApplication: () => void;
	navigateToApplicationDetails: (
		applicationId: string,
		applicationName?: string
	) => void;
	navigateToAddOperation: () => void;
	navigateToOperationDetails: (
		operationId: string,
		operationName?: string,
		operation?: SupportedOperation
	) => void;
	navigateToExportOperationToTask: (
		operationId: string,
		operationName?: string,
		operation?: SupportedOperation
	) => void;
}

export interface RouteHandlerContext {
	selectedApplicationId: string | null;
	selectedApplicationName: string | null;
	selectedOperationId: string | null;
	selectedOperationName: string | null;
	selectedSupportedOperation: SupportedOperation | undefined;
}

export const handleRouteNavigation = (
	href: string,
	actions: RouteHandlerActions,
	context: RouteHandlerContext
): void => {
	const routeInfo = parseHashToRoute(href);

	switch (routeInfo.route) {
	case ROUTES.APPLICATIONS:
		actions.navigateToApplications();
		break;
	case ROUTES.ADD_APPLICATION:
		actions.navigateToAddApplication();
		break;
	case ROUTES.APPLICATION_DETAILS:
		if (context.selectedApplicationId) {
			actions.navigateToApplicationDetails(
				context.selectedApplicationId,
				context.selectedApplicationName || undefined
			);
		}

		break;
	case ROUTES.ADD_OPERATION:
		if (context.selectedApplicationId) {
			actions.navigateToAddOperation();
		}

		break;
	case ROUTES.OPERATION_DETAILS:
		if (
			context.selectedApplicationId &&
				context.selectedOperationId &&
				context.selectedSupportedOperation
		) {
			actions.navigateToOperationDetails(
				context.selectedOperationId,
				context.selectedOperationName || undefined,
				context.selectedSupportedOperation
			);
		}

		break;
	case ROUTES.EXPORT_OPERATION_TO_TASK:
		if (
			context.selectedApplicationId &&
				context.selectedOperationId &&
				context.selectedSupportedOperation
		) {
			actions.navigateToExportOperationToTask(
				context.selectedOperationId,
				context.selectedOperationName || undefined,
				context.selectedSupportedOperation
			);
		}

		break;
	}
};
